/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './ApprovalsMetadataRpc';
import * as Queries from './ApprovalsMetadataRpc.dfc.new';
import type { AdditionalContextArgs } from './ApprovalsMetadataRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseListApprovalSettingsAssetsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListApprovalSettingsAssetsResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listApprovalSettingsAssets',
            References.ListApprovalSettingsAssetsResponseType
          >
        : References.ListApprovalSettingsAssetsResponseType)
    | undefined;
};

export function useListApprovalSettingsAssetsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListApprovalSettingsAssetsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApprovalSettingsAssetsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_APPROVAL_SETTINGS_ASSETS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listApprovalSettingsAssets: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListApprovalSettingsAssetsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListApprovalSettingsAssetsQueryReturn<T>;
}

type UseListApprovalSettingsAssetsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListApprovalSettingsAssetsResponseType>,
    {},
    T extends true
      ? Record<
          'listApprovalSettingsAssets',
          References.ListApprovalSettingsAssetsResponseType
        >
      : References.ListApprovalSettingsAssetsResponseType
  >;

export function useListApprovalSettingsAssetsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListApprovalSettingsAssetsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApprovalSettingsAssetsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_APPROVAL_SETTINGS_ASSETS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listApprovalSettingsAssets: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListApprovalSettingsAssetsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListApprovalSettingsAssetsLazyQueryReturn<T>;
}

type UseListApprovalSettingsAssetsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListApprovalSettingsAssetsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listApprovalSettingsAssets',
        References.ListApprovalSettingsAssetsResponseType
      >
    : References.ListApprovalSettingsAssetsResponseType;
};

export function useListApprovalSettingsAssetsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListApprovalSettingsAssetsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApprovalSettingsAssetsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_APPROVAL_SETTINGS_ASSETS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listApprovalSettingsAssets: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListApprovalSettingsAssetsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListApprovalSettingsAssetsSuspenseQueryReturn<T>;
}

type UseListApprovalTypeOptionsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.ListApprovalTypeOptionsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listApprovalTypeOptions',
            References.ListApprovalTypeOptionsResponseType
          >
        : References.ListApprovalTypeOptionsResponseType)
    | undefined;
};

export function useListApprovalTypeOptionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListApprovalTypeOptionsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApprovalTypeOptionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_APPROVAL_TYPE_OPTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listApprovalTypeOptions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListApprovalTypeOptionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListApprovalTypeOptionsQueryReturn<T>;
}

type UseListApprovalTypeOptionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListApprovalTypeOptionsResponseType>,
    {},
    T extends true
      ? Record<
          'listApprovalTypeOptions',
          References.ListApprovalTypeOptionsResponseType
        >
      : References.ListApprovalTypeOptionsResponseType
  >;

export function useListApprovalTypeOptionsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListApprovalTypeOptionsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApprovalTypeOptionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_APPROVAL_TYPE_OPTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listApprovalTypeOptions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListApprovalTypeOptionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListApprovalTypeOptionsLazyQueryReturn<T>;
}

type UseListApprovalTypeOptionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListApprovalTypeOptionsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listApprovalTypeOptions',
        References.ListApprovalTypeOptionsResponseType
      >
    : References.ListApprovalTypeOptionsResponseType;
};

export function useListApprovalTypeOptionsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListApprovalTypeOptionsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApprovalTypeOptionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_APPROVAL_TYPE_OPTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listApprovalTypeOptions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListApprovalTypeOptionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListApprovalTypeOptionsSuspenseQueryReturn<T>;
}

type UseResolveBreezeAgentNamesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ResolveBreezeAgentNamesResponseType>,
    References.ResolveBreezeAgentNamesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'resolveBreezeAgentNames',
            References.ResolveBreezeAgentNamesResponseType
          >
        : References.ResolveBreezeAgentNamesResponseType)
    | undefined;
};

export function useResolveBreezeAgentNamesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ResolveBreezeAgentNamesResponseType>,
    References.ResolveBreezeAgentNamesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveBreezeAgentNamesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.RESOLVE_BREEZE_AGENT_NAMES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resolveBreezeAgentNames: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseResolveBreezeAgentNamesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseResolveBreezeAgentNamesQueryReturn<T>;
}

type UseResolveBreezeAgentNamesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ResolveBreezeAgentNamesResponseType>,
    References.ResolveBreezeAgentNamesRequestType,
    T extends true
      ? Record<
          'resolveBreezeAgentNames',
          References.ResolveBreezeAgentNamesResponseType
        >
      : References.ResolveBreezeAgentNamesResponseType
  >;

export function useResolveBreezeAgentNamesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ResolveBreezeAgentNamesResponseType>,
    References.ResolveBreezeAgentNamesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveBreezeAgentNamesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.RESOLVE_BREEZE_AGENT_NAMES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resolveBreezeAgentNames: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseResolveBreezeAgentNamesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseResolveBreezeAgentNamesLazyQueryReturn<T>;
}

type UseResolveBreezeAgentNamesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ResolveBreezeAgentNamesResponseType>,
    References.ResolveBreezeAgentNamesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'resolveBreezeAgentNames',
        References.ResolveBreezeAgentNamesResponseType
      >
    : References.ResolveBreezeAgentNamesResponseType;
};

export function useResolveBreezeAgentNamesSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ResolveBreezeAgentNamesResponseType>,
    References.ResolveBreezeAgentNamesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveBreezeAgentNamesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.RESOLVE_BREEZE_AGENT_NAMES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            resolveBreezeAgentNames: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseResolveBreezeAgentNamesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseResolveBreezeAgentNamesSuspenseQueryReturn<T>;
}
